import { render, staticRenderFns } from "./ConfigurationFields.vue?vue&type=template&id=c110a720&scoped=true&"
import script from "./ConfigurationFields.vue?vue&type=script&lang=js&"
export * from "./ConfigurationFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c110a720",
  null
  
)

export default component.exports